import 'react-hot-loader/patch';
import React from 'react';
import {render} from 'react-dom';
import {AppContainer} from 'react-hot-loader';
import ProviderWrapper from './App';
import {applyMiddleware, createStore} from 'redux';
import reducers from './reducers';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

if (window.location.host.startsWith('pcbang.leagueoflegends.co.kr')) {
  alert('pcbang.kr.riotgames.com으로 이동합니다.\n pcbang.leagueoflegends.co.kr은 서비스 종료될 예정입니다.');
  window.location.href = window.location.href.replace(window.location.host, 'pcbang.kr.riotgames.com');
}

const reduxStore = () => {
  const middleware = process.env.NODE_ENV !== 'production' ? applyMiddleware(logger, thunk) : applyMiddleware(thunk);
  return createStore(reducers, middleware);
};

const store = reduxStore();

const target = document.getElementById('app');

const renderApp = Component => {
  render(
    <AppContainer>
      <Component store={store} />
    </AppContainer>,
    target
  );
};

if (target) {
  renderApp(ProviderWrapper);
}

if (module.hot) {
  module.hot.accept('./App', () => {
    renderApp(ProviderWrapper);
  });
  module.hot.accept('./reducers', () => {
    const nextStore = require('./reducers/index');
    store.replaceReducer(nextStore);
  });
}
